import { SafeHtml } from '@angular/platform-browser';

export class Confirmation {
    icon: string;
    title: string;
    bodyText: string | SafeHtml;
    functionName: string | null;
    buttonName: string;
    buttonStatus: string = 'primary';
    showCancel: boolean = true;

    constructor(icon: string, title: string, bodyText: string | SafeHtml, functionName: string | null, buttonName: string, buttonStatus: string = 'primary', showCancel: boolean = true) {
        this.icon = icon;
        this.title = title;
        this.bodyText = bodyText;
        this.functionName = functionName;
        this.buttonName = buttonName;
        this.buttonStatus = buttonStatus;
        this.showCancel = showCancel
    }
}